import s from './error-label.module.scss';

export const ErrorLabel = ({ error }: { error: string }) => {
  return <span className={s['error']}>{error}</span>;
};
